export const timeOfDay = () => {
  const currentDate = new Date();
  const currentTime = currentDate.getHours();

  if (currentTime < 12) return ('Morning');
  if (currentTime < 18) return ('Afternoon');

  return ('Evening');
};
